// extracted by mini-css-extract-plugin
module.exports = {"container":"_2SAn9bHhLthsGECIdgD4od","videoCard":"_2N7ER6J7Lo8FjXzjG-A3Zk"};